/**
 * @file capture/safariDetect.ts
 * @brief Detect Apple Safari / iOS WebKit (not Chrome-on-iOS branded correctly —
 *        also treats CriOS separately). Used to pick mp4 mime + safer hold path.
 *
 * @author DES
 * @date 28-07-2026
 */

/** True for desktop Safari and iOS Safari (WebKit without Chromium branding). */
export function isSafariWebKit(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  // iOS Chrome/Firefox still use WebKit MediaRecorder quirks.
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (isIOS) return true;
  return /Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR|Firefox/i.test(ua);
}

/** Timeslice Safari needs for usable chunks (Whisper / empty-blob quirks). */
export function mediaRecorderTimesliceMs(): number {
  return isSafariWebKit() ? 1000 : 2000;
}

/**
 * Safari pause/resume is flaky (empty first cycle blobs). Prefer stop→restart
 * segments that append to the same chunk list.
 */
export function shouldUseSegmentHold(): boolean {
  return isSafariWebKit();
}
